import moment from 'moment';
import store from '@/store';

export default class StatisticService {
  constructor() {
    this.dataLayer = window.dataLayer || null;
    this.$store = store;

    // Финальное взаимодействие с GTM через метод sendTransaction
    this.TEST_MASK_PURCHASE = 0b00000000000000000001;
    // Финальное взаимодействие с GTM через метод sendTransactionOnlineCall
    this.TEST_MASK_PURCHASE_CALL = 0b00000000000000000010;
    // получаем id из successShipmentResult.booking_reference_number
    this.TEST_MASK_BOOKING_REFERENCE_NUMBER = 0b00000000000000000100;
    // получаем id из successShipmentResult.serviceDeskRequestCode
    this.TEST_MASK_BOOKING_SERVICE_DESK_REQUEST_CODE = 0b00000000000000001000;
    // получаем id из successShipmentResult.waybill_number
    this.TEST_MASK_BOOKING_WAYBILL_NUMBER = 0b00000000000000010000;
    // получаем id после платежного шлюза
    this.TEST_MASK_BOOKING_ONLINE_PAYMANT = 0b00000000000000100000;
    // Отправить из офиса DHL
    this.TEST_MASK_BOOKING_WALK_TYPE = 0b00000000000001000000;
    // Отправить курьером
    this.TEST_MASK_BOOKING_CLICK_TYPE = 0b00000000000010000000;
    // Онлайн звонок
    this.TEST_MASK_BOOKING_CALL_TYPE = 0b00000000000100000000;
    // Не определенный тип отправления
    this.TEST_MASK_BOOKING_ANY_TYPE = 0b00000000001000000000;
    // Оплата картой
    this.TEST_MASK_BOOKING_PAYMENT_CARD = 0b00000000010000000000;
    // Оплата наличными
    this.TEST_MASK_BOOKING_PAYMENT_CASH = 0b00000000100000000000;
    // Оплата картой онлайн
    this.TEST_MASK_BOOKING_PAYMENT_ONLINECARD = 0b00000001000000000000;
    // Оплата не определена
    this.TEST_MASK_BOOKING_PAYMENT_ANY = 0b00000010000000000000;
  }

  sendOffice() {
    this.pushDataLayer({ event: 'officesent' });
  }

  sendCourier() {
    this.pushDataLayer({ event: 'kuriersent' });
  }

  sendCheckoutStep1() {
    const pieces = this.$store.getters['preparation/pieces'];

    const products = pieces.map(piece => this.prepareProduct(piece));

    this.pushDataLayer({
      ecommerce: {
        currencyCode: 'RUB',
        checkout: {
          actionField: { step: 1 },
          products,
        },
      },
      event: 'gtm-ee-event',
      'gtm-ee-event-category': 'Enhanced Ecommerce',
      'gtm-ee-event-action': 'Checkout Step 1',
      'gtm-ee-event-non-interaction': 'True',
    });
  }

  sendCheckoutStep2(type) {
    const pieces = this.$store.getters['preparation/pieces'];

    let deliveryType = '';
    switch (type) {
      case 'walk':
        deliveryType = 'Отправить из офиса DHL';
        break;
      case 'click':
        deliveryType = 'Отправить курьером';
        break;
      case 'call':
        deliveryType = 'Онлайн звонок';
        break;
      default:
        deliveryType = 'Отправить из офиса DHL';
    }

    const typePrice = this.$store.state.preparation.calculateResult[type].price || '';
    const products = pieces.map((piece) => {
      const result = this.prepareProduct(piece);
      result.price = typePrice;
      result.delivery_type = deliveryType;

      return result;
    });

    this.pushDataLayer({
      ecommerce: {
        currencyCode: 'RUB',
        checkout: {
          actionField: { step: 2 },
          products,
        },
      },
      event: 'gtm-ee-event',
      'gtm-ee-event-category': 'Enhanced Ecommerce',
      'gtm-ee-event-action': 'Checkout Step 2',
      'gtm-ee-event-non-interaction': 'True',
    });
  }

  sendCheckoutStep3() {
    const pieces = this.$store.getters['preparation/pieces'];
    const orderType = this.$store.state.preparation.orderType || null;
    let type = '';
    let deliveryType = '';
    switch (orderType) {
      case 1:
        type = 'walk';
        deliveryType = 'Отправить из офиса DHL';
        break;
      case 2:
        type = 'click';
        deliveryType = 'Отправить курьером';
        break;
      case 3:
        type = 'call';
        deliveryType = 'Онлайн звонок';
        break;
      default:
        type = 'walk';
        deliveryType = 'Отправить из офиса DHL';
    }

    let price = this.$store.state.preparation.calculateResult[type].price || '';
    const hasExtras = this.$store.getters['preparation/hasExtras'];
    const actionField = {
      step: 3,
    };

    if (this.$store.state.preparation.selectedExtras.length > 0) {
      const insurance = this.$store.state.preparation.selectedExtras.find(e => e.code === 'II')
        || this.$store.state.preparation.selectedExtras.find(e => e.code === 'ID')
        || this.$store.state.preparation.selectedExtras.find(e => e.code === 'IB') || null;
      const notification = this.$store.state.preparation.selectedExtras.find(e => e.code === 'JD') || null;
      const printer = this.$store.state.preparation.selectedExtras.find(e => e.code === 'PD') || null;
      const hands = this.$store.state.preparation.selectedExtras.find(e => e.code === 'SC') || null;

      if (insurance) {
        if (insurance.cost.exceptions.length > 0) {
          const codes = this.$store.state.preparation.selectedExtras.map(e => e.code);
          if (codes.find(code => insurance.cost.exceptions.includes(code))) {
            actionField.povysh_otvetstvennost = 0;
          } else {
            actionField.povysh_otvetstvennost = insurance.cost.value || '';
            price += insurance.cost.value;
          }
        } else {
          actionField.povysh_otvetstvennost = insurance.cost.value || '';
          price += insurance.cost.value;
        }
      }
      if (notification) {
        if (notification.cost.exceptions.length > 0) {
          const codes = this.$store.state.preparation.selectedExtras.map(e => e.code);
          if (codes.find(code => notification.cost.exceptions.includes(code))) {
            actionField.uvedomlenie = 0;
          } else {
            actionField.uvedomlenie = notification.cost.value || '';
            price += notification.cost.value;
          }
        } else {
          actionField.uvedomlenie = notification.cost.value || '';
          price += notification.cost.value;
        }
      }
      if (printer) {
        if (printer.cost.exceptions.length > 0) {
          const codes = this.$store.state.preparation.selectedExtras.map(e => e.code);
          if (codes.find(code => printer.cost.exceptions.includes(code))) {
            actionField.have_no_printer = 0;
          } else {
            actionField.have_no_printer = printer.cost.value || '';
            price += printer.cost.value;
          }
        } else {
          actionField.have_no_printer = printer.cost.value || '';
          price += printer.cost.value;
        }
      }
      if (hands) {
        if (hands.cost.exceptions.length > 0) {
          const codes = this.$store.state.preparation.selectedExtras.map(e => e.code);
          if (codes.find(code => hands.cost.exceptions.includes(code))) {
            actionField.dostavka_v_ruki = 0;
          } else {
            actionField.dostavka_v_ruki = hands.cost.value || '';
            price += hands.cost.value;
          }
        } else {
          actionField.dostavka_v_ruki = hands.cost.value || '';
          price += hands.cost.value;
        }
      }
    }

    const { selectedPayment } = this.$store.state.preparation;
    const selectedPaymentText = selectedPayment && selectedPayment.title ? selectedPayment.title : '';
    const products = pieces.map((piece) => {
      const result = this.prepareProduct(piece);
      result.price = price;
      result.delivery_type = deliveryType;
      result.data_otpravlenia = `${moment(this.$store.state.preparation.pickUpRange.timeFrom)
        .format('DD.MM.YYYY')}`;
      result.payment = selectedPaymentText;
      result.est_dop_usluga = hasExtras ? 'Да' : 'Нет';

      return result;
    });

    this.pushDataLayer({
      ecommerce: {
        currencyCode: 'RUB',
        checkout: {
          actionField,
          products,
        },
      },
      event: 'gtm-ee-event',
      'gtm-ee-event-category': 'Enhanced Ecommerce',
      'gtm-ee-event-action': 'Checkout Step 3',
      'gtm-ee-event-non-interaction': 'True',
    });
  }

  sendTransactionOnlineCall() {
    const pieces = this.$store.getters['preparation/pieces'];
    const typePrice = this.$store.state.preparation.calculateResult.call.price || '';
    const { sessionId } = this.$store.state.api;

    const { insuredAmount } = this.$store.state.preparation;
    const wasStepTwo = insuredAmount !== 0;

    const sessionRegexp = new RegExp('^[a-f0-9]{32}$', 'i');
    if (!sessionRegexp.test(sessionId)) {
      const senderId = 'sendTransactionOnlineCall';
      this.pushErrorMassage(senderId, {
        senderId,
        date: new Date(),
        sessionId,
        wasStepTwo,
      });
    }

    const products = pieces.map((piece) => {
      const result = this.prepareProduct(piece);
      result.price = typePrice;
      result.delivery_type = 'Онлайн звонок';

      return result;
    });

    let testDeveloper = null;
    // eslint-disable-next-line no-bitwise
    testDeveloper |= this.TEST_MASK_PURCHASE_CALL;

    this.pushDataLayer({
      ecommerce: {
        currencyCode: 'RUB',
        purchase: {
          actionField: {
            testDeveloper,
            id: sessionId,
            revenue: typePrice,
          },
          products,
        },
      },
      event: 'gtm-ee-event',
      'gtm-ee-event-category': 'Enhanced Ecommerce',
      'gtm-ee-event-action': 'Purchase',
      'gtm-ee-event-non-interaction': 'False',
    });
  }

  sendTransaction() {
    const pieces = this.$store.getters['preparation/pieces'];
    const orderType = this.$store.state.preparation.orderType || null;
    let type = '';
    let deliveryType = '';
    switch (orderType) {
      case 1:
        type = 'walk';
        deliveryType = 'Отправить из офиса DHL';
        break;
      case 2:
        type = 'click';
        deliveryType = 'Отправить курьером';
        break;
      case 3:
        type = 'call';
        deliveryType = 'Онлайн звонок';
        break;
      default:
        type = 'walk';
        deliveryType = 'Отправить из офиса DHL';
    }

    let price = this.$store.state.preparation.calculateResult[type].price || '';
    const hasExtras = this.$store.getters['preparation/hasExtras'];

    const { successShipmentResult } = this.$store.state.preparation;
    const orderId = successShipmentResult.booking_reference_number
      || successShipmentResult.serviceDeskRequestCode
      || successShipmentResult.waybill_number;
    const actionField = {
      id: orderId,
    };

    const sessionRegexp = new RegExp('^[a-f0-9]{32}$', 'i');
    if (sessionRegexp.test(orderId)) {
      const {
        locationFrom, locationTo, servicePointFrom, servicePointTo,
      } = this.$store.state.preparation;
      const senderId = 'sendTransaction';
      this.pushErrorMassage(senderId, {
        senderId,
        date: new Date(),
        orderId,
        orderType,
        locationFrom,
        locationTo,
        servicePointFrom,
        servicePointTo,
      });
    }

    if (this.$store.state.preparation.selectedExtras.length > 0) {
      const insurance = this.$store.state.preparation.selectedExtras.find(e => e.code === 'II')
        || this.$store.state.preparation.selectedExtras.find(e => e.code === 'ID')
        || this.$store.state.preparation.selectedExtras.find(e => e.code === 'IB') || null;
      const notification = this.$store.state.preparation.selectedExtras.find(e => e.code === 'JD') || null;
      const printer = this.$store.state.preparation.selectedExtras.find(e => e.code === 'PD') || null;
      const hands = this.$store.state.preparation.selectedExtras.find(e => e.code === 'SC') || null;

      if (insurance) {
        if (insurance.cost.exceptions.length > 0) {
          const codes = this.$store.state.preparation.selectedExtras.map(e => e.code);
          if (codes.find(code => insurance.cost.exceptions.includes(code))) {
            actionField.povysh_otvetstvennost = 0;
          } else {
            actionField.povysh_otvetstvennost = insurance.cost.value || '';
            price += insurance.cost.value;
          }
        } else {
          actionField.povysh_otvetstvennost = insurance.cost.value || '';
          price += insurance.cost.value;
        }
      }
      if (notification) {
        if (notification.cost.exceptions.length > 0) {
          const codes = this.$store.state.preparation.selectedExtras.map(e => e.code);
          if (codes.find(code => notification.cost.exceptions.includes(code))) {
            actionField.uvedomlenie = 0;
          } else {
            actionField.uvedomlenie = notification.cost.value || '';
            price += notification.cost.value;
          }
        } else {
          actionField.uvedomlenie = notification.cost.value || '';
          price += notification.cost.value;
        }
      }
      if (printer) {
        if (printer.cost.exceptions.length > 0) {
          const codes = this.$store.state.preparation.selectedExtras.map(e => e.code);
          if (codes.find(code => printer.cost.exceptions.includes(code))) {
            actionField.have_no_printer = 0;
          } else {
            actionField.have_no_printer = printer.cost.value || '';
            price += printer.cost.value;
          }
        } else {
          actionField.have_no_printer = printer.cost.value || '';
          price += printer.cost.value;
        }
      }
      if (hands) {
        if (hands.cost.exceptions.length > 0) {
          const codes = this.$store.state.preparation.selectedExtras.map(e => e.code);
          if (codes.find(code => hands.cost.exceptions.includes(code))) {
            actionField.dostavka_v_ruki = 0;
          } else {
            actionField.dostavka_v_ruki = hands.cost.value || '';
            price += hands.cost.value;
          }
        } else {
          actionField.dostavka_v_ruki = hands.cost.value || '';
          price += hands.cost.value;
        }
      }
    }
    actionField.revenue = price;

    const selectedPayment = this.$store.state.preparation.selectedPayment
      ? this.$store.state.preparation.selectedPayment.title : '';
    const products = pieces.map((piece) => {
      const result = this.prepareProduct(piece);
      result.price = price;
      result.delivery_type = deliveryType;
      result.data_otpravlenia = `${moment(this.$store.state.preparation.pickUpRange.timeFrom)
        .format('DD.MM.YYYY')}`;
      result.payment = selectedPayment;
      result.est_dop_usluga = hasExtras ? 'Да' : 'Нет';

      return result;
    });

    let testDeveloper = null;
    const paymentType = this.$store.state.preparation.selectedPayment
      ? this.$store.state.preparation.selectedPayment.paymentType : null;
    switch (paymentType) {
      case 1:
        // eslint-disable-next-line no-bitwise
        testDeveloper |= this.TEST_MASK_BOOKING_PAYMENT_CARD;
        break;
      case 2:
        // eslint-disable-next-line no-bitwise
        testDeveloper |= this.TEST_MASK_BOOKING_PAYMENT_CASH;
        break;
      case 3:
        // eslint-disable-next-line no-bitwise
        testDeveloper |= this.TEST_MASK_BOOKING_PAYMENT_ONLINECARD;
        break;
      default:
        // eslint-disable-next-line no-bitwise
        testDeveloper |= this.TEST_MASK_BOOKING_PAYMENT_ANY;
    }

    switch (orderType) {
      case 1:
        // eslint-disable-next-line no-bitwise
        testDeveloper |= this.TEST_MASK_BOOKING_WALK_TYPE;
        break;
      case 2:
        // eslint-disable-next-line no-bitwise
        testDeveloper |= this.TEST_MASK_BOOKING_CLICK_TYPE;
        break;
      case 3:
        // eslint-disable-next-line no-bitwise
        testDeveloper |= this.TEST_MASK_BOOKING_CALL_TYPE;
        break;
      default:
        // eslint-disable-next-line no-bitwise
        testDeveloper |= this.TEST_MASK_BOOKING_ANY_TYPE;
    }

    if (successShipmentResult.booking_reference_number) {
      // eslint-disable-next-line no-bitwise
      testDeveloper |= this.TEST_MASK_BOOKING_REFERENCE_NUMBER;
    } else if (successShipmentResult.serviceDeskRequestCode) {
      // eslint-disable-next-line no-bitwise
      testDeveloper |= this.TEST_MASK_BOOKING_SERVICE_DESK_REQUEST_CODE;
    } else if (successShipmentResult.waybill_number) {
      // eslint-disable-next-line no-bitwise
      testDeveloper |= this.TEST_MASK_BOOKING_WAYBILL_NUMBER;
    }

    // eslint-disable-next-line no-bitwise
    testDeveloper |= this.TEST_MASK_PURCHASE;

    actionField.testDeveloper = testDeveloper;

    this.pushDataLayer({
      ecommerce: {
        currencyCode: 'RUB',
        purchase: {
          actionField,
          products,
        },
      },
      event: 'gtm-ee-event',
      'gtm-ee-event-category': 'Enhanced Ecommerce',
      'gtm-ee-event-action': 'Purchase',
      'gtm-ee-event-non-interaction': 'False',
    });
  }

  prepareProduct(piece) {
    const locationFrom = { ...this.$store.state.preparation.locationFrom };
    const locationTo = { ...this.$store.state.preparation.locationTo };
    const result = {
      name: piece.type.alias === 'NonDocuments' ? 'gruz' : 'document',
      id: piece.type.type + 1,
      category: piece.weight,
      quantity: 1,
      mesto_otpravlenia: `${locationFrom.CountryAlias}, ${locationFrom.CityAlias}`,
      mesto_naznachenia: `${locationTo.CountryAlias}, ${locationTo.CityAlias}`,
    };

    if (piece.type.alias === 'NonDocuments') {
      result.variant = `${piece.dimensions.height}x${piece.dimensions.width}x${piece.dimensions.depth}см`;
    }

    return result;
  }

  pushErrorMassage(senderId, messageObject) {
    let errorMessage = null;
    try {
      errorMessage = JSON.stringify(messageObject);
    } catch (error) {
      errorMessage = JSON.stringify({
        senderId,
        ...error,
      });
    }
    this.pushDataLayer.push({
      errorMessage,
      event: 'gtm-error-event',
    });
  }

  pushDataLayer(event) {
    if (this.dataLayer) {
      this.dataLayer.push(event);
    }
  }
}
